module.exports = __webpack_public_path__ + "static/media/WTAM.f38faa2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/WTAM.jpg
// module id = 1786
// module chunks = 1